import React from 'react';

import { flagStyles } from '../settings';

const SvgCV = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-1200px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgCV;
